<template>
  <div class="hero-slideshow">
    <slick
      ref="heroSlick"
      :options="{
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 5000,
        fade: true,
        pauseOnHover: false,
      }"
      @beforeChange="onChange"
    >
      <article v-for="(banner, key) in banners" v-bind:key="key">
        <img class="desktop" :src="banner.image" :alt="banner.title" />
        <img class="mobile" :src="banner.mobile_image" :alt="banner.title" />
        <div class="content">
          <h1>
            {{ banner.title }}
          </h1>
          <p>I’m interested in…</p>
          <div class="actions">
            <a v-for="(link, key) in banner.links" v-bind:key="key"  :href="link.value" class="button">{{link.title}}</a>
          </div>
        </div>
      </article>

    </slick>

    <div class="slide-controller" v-if="banners.length > 1">
      <img src="/images/icons/previous_arrow.svg" alt="" @click="prev()" />
      <div class="pages">
        <span
          v-for="(slide, i) in banners.length"
          :key="i"
          :class="{ active: currentSlide === i }"
          @click="goToSlide(i)"
        ></span>
      </div>
      <img src="/images/icons/next_arrow.svg" alt="" @click="next()" />
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick";

export default {
  props: {
      banners: Array
  },
  data() {
    return {
      currentSlide: 0,
    };
  },
  components: {
    slick: VueSlickCarousel,
  },
  mounted() {
    console.log(this.banners)
  },
  methods: {
    next() {
      this.$refs.heroSlick.next();
    },
    prev() {
      this.$refs.heroSlick.prev();
    },
    onChange(event, slick, currentSlide, nextSlide) {
      this.currentSlide = nextSlide;
    },
    goToSlide(i) {
      this.$refs.heroSlick.goTo(i);
    },
  },
};
</script>

<style scoped lang="scss">
.slide-controller {
  position: absolute;
  bottom: 32px;
  left: 0;
  right: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;

  max-width: 192px;

  margin: 0 auto;

  img {
    cursor: pointer;
  }

  .pages {
    display: flex;

    @media (max-width: 724px) {
      max-width: 240px;
    }

    span {
      height: 2px;
      width: 28px;

      background: #fff;

      opacity: 0.2;

      transition: all 0.3s ease-in-out;
      cursor: pointer;

      &:nth-child(2) {
        margin: 0 2px;
      }

      &.active {
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/sliders/HeroSlider.vue